var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AsynCardContainer',{attrs:{"loading":_vm.loading,"sizes":{
    default: 12,
    sm: 12,
    lg: 6
  },"visibleCard":""}},[_c('div',{staticClass:"card-header-custom pt-4"},[_c('h5',{staticClass:"card-title mb-0 font-weight-bold"},[_vm._v(" "+_vm._s(_vm.$tc("AUDIENCE_PAGE.TITLE_HEATMAP"))+" ")])]),_c('div',{staticClass:"pt-4"},[(!_vm.loading)?_c('apexchart',{attrs:{"type":"heatmap","width":"100%","options":_vm.chartOptions,"series":_vm.series}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }